module.exports = React;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","var":"React","commonjs":"react","commonjs2":"react","amd":"react"}
 ** module id = 7
 ** module chunks = 0
 **/